export default __webpack_public_path__ + "static/media/scissorshand.119af2e3.png";